export const getQueryParamValue = (paramName: string) => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(paramName);
  } catch (err) {
    console.error("getQueryParamValue", err);
  }
}
